<template>
  <div id="app" :class="platformType" :style="{'--primaryColor': primaryColor, '--lightColor': lightColor}">
    <router-view/>
  </div>
</template>

<script>
import deviceUtils from './util/deviceUtils'
import {on} from 'element-ui/lib/utils/dom'
import browserUtils from './util/browserUtils'

export default {
  name: 'App',
  data () {
    return {
      primaryColor: '#005ea6',
      lightColor: '#367eb1'
    }
  },
  computed: {
    platformType: function () {
      return 'platform-' + deviceUtils.getDeviceType().toLowerCase()
    }
  },
  methods: {
  },
  created () {
  },
  mounted () {
    /* ie下部分路由不跳转修复 */
    if (browserUtils.isIE()) {
      on(window, 'hashchange', () => {
        let currentPath = window.location.hash.slice(1)
        if (this.$route.path !== currentPath) {
          this.$router.replace(currentPath)
        }
      })
    }
  }
}
</script>

<style lang="scss">
/* 引入样式 */
@import "styles/index";

#app {
  width: 100%;
  height: 100%;
  @include execute(var(--primaryColor), var(--lightColor))
}
</style>



// WEBPACK FOOTER //
// src/App.vue